exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-5f1cb41a]{position:fixed;top:25px;right:unset;bottom:unset;left:50%;z-index:9;display:block;width:auto;height:unset}.fade-enter-active[data-v-5f1cb41a],.fade-leave-active[data-v-5f1cb41a]{transition:top .5s}.fade-enter[data-v-5f1cb41a],.fade-leave-to[data-v-5f1cb41a]{top:-50px}", ""]);

// exports
